module.exports = "<p>\r\n  footer works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/alliance/footer/footer.component.html
// module id = ./src/app/shared-components/alliance/footer/footer.component.html
// module chunks = main